import React, { Fragment } from 'react';
import {
    Segment,
    Button,
    Header,
    Form,
    Input,
    Grid,
    Message,
    Loader
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';
import request from '../Util/request';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CreateCommittee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            academicYears: false,
            types: false,
            members: false,
            selectedMembers: [],
            selectedMembersErr: false
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.createCommittee = this.createCommittee.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }
    componentWillMount() {
        request.fetchCommitteeTypes().then(types => this.setState({ types }));
        request.fetchAcademicYears().then(academicYears => this.setState({ academicYears: academicYears.reverse() }));
        request.fetchMembersOptions().then(members => this.setState({ members }));
    }

    createCommittee() {
        if (!this.state.type || !this.state.number || !this.state.date || !this.state.academicYear || !this.state.head || this.state.selectedMembers.length !== 5) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.type) { this.setState({ typeErr: true }); } else { this.setState({ typeErr: false }); }
            if (!this.state.number) { this.setState({ numberErr: true }); } else { this.setState({ numberErr: false }); }
            if (!this.state.date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.head) { this.setState({ headErr: true }); } else { this.setState({ headErr: false }); }
            if (this.state.selectedMembers.length !== 5) { this.setState({ selectedMembersErr: true }, () => toast('Komisija mora imati tačno pet članova!')); } else { this.setState({ selectedMembersErr: false }); }
        } else {
            this.setState({ disableCreateButton: true });
            let selectedMembers = this.state.selectedMembers.map((e) => {
                console.log('head', this.state.head);
                if (this.state.head === e.key) {
                    return { employeeId: e.key, committeeMemberTypeKey: 'head' };
                }
                return { employeeId: e.key, committeeMemberTypeKey: 'member' };
            });
            let obj = {
                committeeTypeKey: this.state.type,
                decisionNumber: this.state.number,
                decisionDate: new Date(this.state.date),
                academicYearId: this.state.academicYear,
                committeeMembers: selectedMembers,


            };

            request.createCommittee(obj)
                .then(() => { toast('Uspješno ste kreirali komisiju.'); this.props.closeForm(); })
                .then(() => this.props.getAllCommittee())
                .catch(err => {
                    if (err.response.data === 'Committee already exist!') {
                        toast('Stalna komisija za odabranu godinu već postoji.');
                    } else { toast('Došlo je do greške. Komisija nije kreirana.'); }
                    this.setState({ disableCreateButton: false });
                    console.log('Failed to create committee.');
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        }, () => {
            if (name === 'professor')localStorage.setItem('selectedProfessors', JSON.stringify(value));

            if (name === 'assistant')localStorage.setItem('selectedAssistants', JSON.stringify(value));
        });
    }

    render() {
        return (


            <Fragment>
                <Segment clearing>
                    <Header as="h3">
                        Kreiranje komisije
                    </Header>
                </Segment>
                <Segment clearing>

                    <Form>


                        <Grid columns="equal" centered className="stackable">
                            <Grid.Column>
                                <Form.Group widths="equal">
                                    <Form.Field required error={this.state.typeErr}>
                                        <label>
                                            Tip komisije
                                        </label>
                                        <Form.Dropdown
                                            loading={!this.state.types}
                                            clearable
                                            placeholder="Odaberite tip"
                                            value={this.state.type}
                                            onChange={this.handleInputChange}
                                            name="type"
                                            options={this.state.types}
                                            search
                                            fluid
                                            selection

                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.numberErr}>
                                        <label>
                                            Broj odluke
                                        </label>
                                        <input
                                            fluid
                                            placeholder="Odaberite broj"
                                            control={Input}
                                            value={this.state.number}
                                            name="number"
                                            onChange={(e) => this.setState({ number: e.target.value })}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group widths="equal">
                                    <Form.Field
                                        required
                                        control={DateTimePicker}
                                        label="Datum odluke "
                                        format="D. M. YYYY."
                                        defaultValue={new Date()}
                                        value={this.state.date}
                                        time={false}
                                        onChange={this.handleDateChange.bind(null, 'date')}
                                        style={{ borderWidth: '0px' }}
                                        error={this.state.dateErr}
                                    />
                                    <Form.Field required >
                                        <label>
                                            Akademska godina
                                        </label>
                                        <Form.Dropdown
                                            clearable
                                            loading={!this.state.academicYears}
                                            placeholder="Odaberite godinu"
                                            value={this.state.academicYear}
                                            onChange={this.handleInputChange}
                                            name="academicYear"
                                            options={this.state.academicYears}
                                            search
                                            fluid
                                            selection
                                            required
                                            error={this.state.academicYearErr}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Grid.Column>
                            <Grid.Column>
                                <Form.Field>
                                    <Message >
                                        <Form.Field required error={this.state.selectedMembersErr}>
                                            <label>
                                                Članovi komisije
                                            </label>
                                            <Form.Dropdown
                                                loading={!this.state.members}
                                                clearable
                                                placeholder="Odaberite članove"
                                                value={this.state.selectedMembers}
                                                onChange={this.handleInputChange}
                                                name="selectedMembers"
                                                options={this.state.members}
                                                search
                                                fluid
                                                multiple
                                                selection
                                            />
                                        </Form.Field>
                                        <Form.Field required error={this.state.headErr}>
                                            <label>
                                                Predsjednik komisije
                                            </label>
                                            <Form.Dropdown
                                                clearable
                                                placeholder="Odaberite predsjednika"
                                                value={this.state.head}
                                                onChange={this.handleInputChange}
                                                name="head"
                                                options={this.state.selectedMembers}
                                                search
                                                fluid
                                                selection
                                                required

                                            />
                                        </Form.Field>
                                    </Message>
                                </Form.Field>
                            </Grid.Column>
                        </Grid>

                        <br />

                        <Button
                            basic
                            color="blue"
                            disabled={this.state.disableCreateButton}
                            floated="right"
                            onClick={() => this.props.closeForm()}
                        >
                            Odustani

                        </Button>

                        <Button primary color="blue" disabled={this.state.disableCreateButton} onClick={this.createCommittee} floated="right">
                            Kreiraj
                        </Button>
                        <Loader active={this.state.disableCreateButton} />


                    </Form>

                </Segment>
                <ToastContainer hideProgressBar />

            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Comitee/CreateCommittee.js